import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import AppSettings from "../../utils/appSettings";

const settings = {
  authority: AppSettings.identityServer,
  client_id: AppSettings.clientId,
  redirect_uri: `${window.location.origin}/signin-oidc`,
  post_logout_redirect_uri: `${window.location.origin}`,
  response_type: "code",
  scope: `${AppSettings.scope} offline_access`,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,

  extraHeaders: {
    Authorization: `Basic ${btoa(AppSettings.clientId)}`,
  },
};

const userManager = new UserManager(settings);

export default userManager;
